import styled from "@emotion/styled"

export const SVG = styled.svg`
  display: none;
  path {
    fill: currentColor;
  }
`
